// =============================================================================
// Copyright   : 2020 semantics GmbH
// Date        : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
// Author      : Dirk Rothe
// Worker      : $Author: d.rothe $
// Revision    : $Rev: 156393 $
// Purpose     : config dashboard panels
// =============================================================================
// ---Third-party imports
import React from 'react'

// ---Framework imports
import {isString} from 'ldash'
import log from 'uix/logging'
import {DashSegment} from 'uix/components/grid'

// ---Local imports
import {DomainConfigTable, ConfigMenu} from './components'

// ---Exports

const DomainConfigPanel = ({section, header = 'Konfiguration', i18n}) => {
  if (isString(section)) {
    section = [section]
  }
  return (
    <DashSegment header={header} menu={<ConfigMenu basic />}>
      {section.map((sec, i) => (
        <DomainConfigTable key={sec} basic section={sec} />
      ))}
    </DashSegment>
  )
}

export const DashDomainConfig = {
  Comp: DomainConfigPanel,
  datatypes: ['domain'],
}
